import _ from "lodash";
import TechBaseText from "DisplayCoreV2/Text";
import { isOver18YearsOld, validateMyKad } from "utils";

export const requireRule = {
  required: true,
  message: <TechBaseText content="{{REQUIRED_MESSAGE}}" />
};

export const ValidateICRule = (identityType = "IC") => ({
  validator: (x, value) =>
    _.isEmpty(value) || validateMyKad(value) || identityType !== "IC"
      ? Promise.resolve()
      : Promise.reject(new Error(TechBaseText({ content: "{{INVALID_IC_FORMAT}}" })))
});

export const ValidateAgeRule = {
  validator: (x, value) =>
    isOver18YearsOld(value)
      ? Promise.resolve()
      : Promise.reject(new Error(TechBaseText({ content: "{{REGISTER_AGE_RESTRICTION}}" })))
};

export const validateChineseRule = {
  validator: (x, value) => {
    const chineseCharRegex = /^[\u4e00-\u9fa5]+$/;
    return _.isEmpty(value) || chineseCharRegex.test(value)
      ? Promise.resolve()
      : Promise.reject(new Error(TechBaseText({ content: "{{ONLY_CHINESE_CHARACTER_ARE_ALLOWED}}" })));
  }
};

export const validateMobileNumberRule = (withoutPrefix = true, mobileCode = null) => ({
  validator: (_rule, value = "") => {
    // If no value, skip validation (let required rule handle it)
    if (!value || _.isEmpty(String(value).trim())) {
      return Promise.resolve();
    }

    const cleaned = String(value).replace(/[\s-()]/g, "");
    let regex;
    let shouldValidate = false;

    if (!withoutPrefix) {
      // WITH prefix: check what the string starts with
      const trimmedValue = String(value).trim();
      
      if (trimmedValue.startsWith('+65') || trimmedValue.startsWith('65') || 
          trimmedValue.startsWith('+60') || trimmedValue.startsWith('60')) {
        // Use strict validation for Malaysia (+60/60) and Singapore (+65/65)
        regex = /^(?:\+?60(?:1\d{8,9})|\+?65(?:[89]\d{7}))$/;
        shouldValidate = true;
      } else {
        // For other prefixes, only check that it contains valid characters
        regex = /^[\d\-()+ ]+$/;
        shouldValidate = true;
      }
    } else {
      // WITHOUT prefix: only validate for specific mobile codes
      if (mobileCode) {
        const normalizedCode = String(mobileCode).replace(/\+/g, "");
        
        if (normalizedCode === "6") {
          regex = /^01\d{8,9}$/;
          shouldValidate = true;
        } else if (normalizedCode === "60") {
          regex = /^1\d{8,9}$/;
          shouldValidate = true;
        } else if (normalizedCode === "65") {
          // Singapore: starts with 8 or 9, total 8 digits
          regex = /^[89]\d{7}$/;
          shouldValidate = true;
        }
        // For any other mobile code, don't validate format
      }
    }

    // Only validate if we should validate and have a regex
    if (shouldValidate && regex) {
      const testValue = !withoutPrefix ? String(value).trim() : cleaned;
      return regex.test(testValue)
        ? Promise.resolve()
        : Promise.reject(new Error(TechBaseText({ content: "{{INVALID_MOBILE_NUMBER}}" })));
    }

    // If we shouldn't validate (other country codes), always pass
    return Promise.resolve();
  }
});


export const validatePostCodeRule =  {
  validator: (x, value) => {
    return /^\d{3,8}$/.test(value)
      ? Promise.resolve()
      : Promise.reject(new Error(TechBaseText({ content: "{{INVALID_POSTCODE}}" })));
  }
}
